
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/elections/[stateElection]/exit-poll-result",
      function () {
        return require("private-next-pages/elections/[stateElection]/exit-poll-result/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/elections/[stateElection]/exit-poll-result"])
      });
    }
  